module.exports = __webpack_public_path__ + "img/loadingV2.cb751700.gif";